import { useIntl } from '@edx/frontend-platform/i18n';
import { Form, StatefulButton } from '@edx/paragon';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';

import ArrowButton from '../../common-components/ArrowButton';
import { FormGroup } from '../../common-components';
import { setRedirectTarget } from '../../common-components/data/actions';
import { LOGIN_PAGE } from '../../data/constants';
import { updatePathWithQueryParams } from '../../data/utils';
import { OTP_LENGTH } from '../../forgot-password-code/data/constants';
import messages from '../messages';

import { globalBackgroundPass1 } from '@edx/brand';
import { globalBackgroundPass2 } from '@edx/brand';
import { globalBackgroundPass3 } from '@edx/brand';
import { globalBackgroundPass4 } from '@edx/brand';


const ForgotPasswordForm = ({
  email,
  setEmail,
  validationError,
  handleBlur,
  submitState,
  handleSubmit,
}) => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleBackToLogin = () => {
    dispatch(setRedirectTarget(LOGIN_PAGE));
    navigate(updatePathWithQueryParams(LOGIN_PAGE));
  };

  return (
    <Form id="forget-password-form" name="forget-password-form" className="flex-center-column flex-fill all-the-forget-password-form-new">
      <div className='flex-center-column' style={{width: 442}}>
        <div className="background-pass-1"><img src={globalBackgroundPass1} alt="Background Pass 1" /></div>
        <div className="background-pass-2"><img src={globalBackgroundPass2} alt="Background Pass 2" /></div>
        <div className="background-pass-3"><img src={globalBackgroundPass3} alt="Background Pass 3" /></div>
        <div className="background-pass-4"><img src={globalBackgroundPass4} alt="Background Pass 4" /></div>
        <div className='forget-password-warpper'>
          <h1 className="page-title mb-0 page-title-forget">
            {formatMessage(messages['forgot.password.page.heading'])}
          </h1>
          <div className="flex-center-column">
            <div className="flex-center-column">
              <p className="regular-text mb-0 regular-text-forget">
                {formatMessage(messages['forgot.password.page.instructions'], { length: <span style={{ fontWeight: 700 }}>{OTP_LENGTH}</span> })}
              </p>
              <FormGroup
                absoluteLabel={formatMessage(messages['forgot.password.email.input.label'])}
                name="email"
                value={email}
                className="page-input-forget"
                autoComplete="on"
                errorMessage={validationError}
                showErrorMessage
                inputStyle={{ width: 350, height: 50, borderRadius: 24, fontSize: 20 }}
                handleChange={(e) => setEmail(e.target.value)}
                handleBlur={handleBlur}
                // handleFocus={handleFocus}
                placeholder={formatMessage(messages['forgot.password.email.placeholder'])}
              />
            </div>
          </div>
          <div className="flex-center-column page-button-forget">
            <StatefulButton
              id="submit-forget-password"
              name="submit-forget-password"
              type="submit"
              className="logistration-btn"
              state={submitState}
              labels={{
                default: formatMessage(messages['forgot.password.page.submit.button']),
                pending: '',
              }}
              onClick={handleSubmit}
              onMouseDown={(e) => e.preventDefault()}
            />
            <ArrowButton className="page-button-forget-single-back" text={formatMessage(messages['back.to.sign.in'])} onClick={handleBackToLogin} />
          </div>
        </div>
      </div>
    </Form>
  );
};

ForgotPasswordForm.propTypes = {
  email: PropTypes.string.isRequired,
  submitState: PropTypes.string.isRequired,
  validationError: PropTypes.string.isRequired,
  setEmail: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default ForgotPasswordForm;
